// extracted by mini-css-extract-plugin
module.exports = {"listCase":"Case_listCase_24yS1","brandList":"Case_brandList_lSvs1","navigation":"Case_navigation_2bmnC"};